import type {
    ImageStoreListPayload,
    ImageStorePayload,
    ImageStoreResponse,
} from '@/types/apps/image-store.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';

type ImageStoreListResponse = ApiResponse<PaginatedResult<ImageStoreResponse>>;

export class ImageStoreService implements Deletable, Creatable, Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    public endpoints = {
        base: () => '/api/image-store',
        createList: () => '/api/image-store/create-list',
        detail: (id: string) => `/api/image-store/${id}`,
    };

    public index(params?: QueryParams): Promise<ImageStoreListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public create(
        payload: ImageStorePayload
    ): Promise<ApiResponse<ImageStoreResponse>> {
        const form = this.apiClient.buildFormData(payload);

        return this.apiClient.postApi(this.endpoints.base(), form);
    }

    public createList(
        payload: ImageStoreListPayload
    ): Promise<ApiResponse<ImageStoreResponse>> {
        const form = new FormData();

        form.append('entityName', payload.entityName);
        form.append('entityId', payload.entityId);
        payload.file.forEach(file => form.append('file', file));

        return this.apiClient.postApi(this.endpoints.createList(), form);
    }

    public destroy(
        ids: string[],
        isHardDeleted: boolean = true
    ): Promise<ApiResponse<void>> {
        return this.apiClient.destroyApi(
            this.endpoints.base(),
            ids,
            isHardDeleted
        );
    }
}
